export const API_CODE = {
  STATUS_200: 200,
  STATUS_201: 201,
  STATUS_204: 204
};
export const API_ERROR_CODES = {
  STATUS_400: 400,
  STATUS_401: 401,
  STATUS_402: 402,
  STATUS_403: 403,
  STATUS_404: 404,
  STATUS_412: 412,
  STATUS_422: 422,
  STATUS_500: 500,
  UIS_1012: 'UIS-1012',
  UIS_1005: 'UIS-1005',
  OTP_1001: 'OTP-1001', // otp limit exceeded
  OTP_1002: 'OTP-1002', // account locked
  UIS_1041: 'UIS-1041'
};

export const REGEX = {
  UPPER_CASE_REGEX: /(?=.*[A-Z])/,
  LOWER_CASE_REGEX: /(?=.*[a-z])/,
  DIGIT_CASE_REGEX: /(?=.*\d)/,
  SPECIAL_CASE_REGEX: /(?=.*[-+_!@#$%^&*.,?])/,
  SPACE_REGEX: /(?=.*\s)/,
  EMAIL_REGEX: /^(?=[\w\s-+.])\s*[-+.'\w]+@[-.\w]+\.[-.\w]+\s*$/,
  HUBSPOT_COOKIE_REGEX: '(^|;)\\s*hubspotutk\\s*=\\s*([^;]+)',
  ONLY_STRING_REGEX: /([A-Za-z])$/,
  REPLACE_STRING_REGEX: /[^\d.-]/g,
  REPLACE_SLASH: /\//g,
  EXCEPT_SLASH_AND_QUOTES_REGEX: /^[^/\\'"]+$/,
  FIND_ALL_WHITESPACE: /\s/g,
  CARD_NUMBER_SPACE_REGEX: /\d{4}(?=.)/g,
  WATCH: /watch\?v=/,
  ONLY_ALPHABETS_AND_SPACE_ALLOWED: /^[A-Za-z\s]*$/,
  YOUTUBE_VIDEO_ID: /(?:\?v=|\/embed\/|\.be\/|\/v\/|\/watch\?v=)([^&?}/\s]{11})/,
  PASSWORD_REGEX: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*\W)[A-Za-z\d\W]{10,}$/
};

export const JURISDICTION = {
  HK: { code: 'HK', name: 'Hong Kong SAR' },
  SG: { code: 'SG', name: 'Singapore' },
  VG: { code: 'VG', name: 'British Virgin Islands' },
  OTHER_JURISDICTION: 'other-jurisdiction'
};
export const COMPANY_REGISTRATION_COUNTRY = {
  HONG_KONG: 'HongKong',
  SINGAPORE: 'Singapore'
};
export const VERIFY_OTP_STATUS = {
  VERIFIED: 'VERIFIED',
  EXPIRED: 'EXPIRED'
};
export const COUNTRY_CODE = {
  ALPHA_2: 'alpha-2'
};

export const FILE_UPLOAD_TYPE = {
  PDF: 'application/pdf',
  PNG: 'image/png',
  JPEG: 'image/jpeg',
  JPG: 'image/jpg',
  MSWORD: 'application/msword',
  OFFICE_DOCUMENT: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
};

export const MUI_COLORS = {
  CORAL: '#E15741',
  WHITE: '#FFFFFF',
  SILVER_MEDAL: '#D6D6D6',
  SUNSET_ORANGE: '#FF4F42',
  EXTRA_LIGHT_GRAY: '#F9F9F9',
  PURPLE: '#2D0D45',
  DARK_CHARCOAL: '#2F2F2F',
  DARK_GRAY: '#474747',
  GRAY: '#7A7A7A',
  LIGHT_CREAM: '#F9DBD1',
  LIGHT_GREEN: '#E6F2F1',
  LIGHT_YELLOW: '#FFEDDE',
  LIGHT_GRAY: '#F5F1ED',
  DARK_GRAY_MAIN: '#464646',
  GREEN: '#097D75',
  SUNGLOW: '#FFC730',
  BLUE: '#1B6BD3',
  WHATS_APP_GREEN: '#25D365',
  PINK: '#FCEFE8',
  PAPAYA_WHIP: '#FFF3D4',
  DARK_GREEN: '#043734',
  MID_NIGHT: '#212B36',
  DARK_GRAYISH_BLUE: '#919EAB',
  WHITE_SMOKE: '#f5f5f5',
  CHARCOAL: '#333333',
  PANTONE: '#EC9183',
  BLACK: '#000000',
  EERIE_BLACK: '#1B1B1B',
  BROWN: '#6F5511'
};
export const AVATAR_COlORS = ['#2D0D45', '#097D75', '#043734', '#1B6BD3', '#FFC730', '#F9DBD1', '#DAD2BC', '#E2FBFA'];

export const STATUS = {
  FALSE: 'false',
  TRUE: 'true'
};

export const DateFormats = {
  DDMMMYYY: 'DD MMM YYYY'
};

export const APPLICATION_COMPLETION_PERCENTAGE = {
  COMPLETION_0: 0,
  COMPLETION_20: 20,
  COMPLETION_40: 40,
  COMPLETION_60: 60,
  COMPLETION_80: 80
};

export const ERROR_STATUS_CODE = {
  ONB_1038: 'ONB-1038',
  ONB_1008: 'ONB-1008'
};

export const FILE_SIZE = {
  FOUR_MB_IN_BYTES: 4194304
};

export const SITE_URL = 'https://statrys.com/';
export const EXTERNAL_LINKS = {
  APPLE_STORE: 'https://apps.apple.com/us/app/statrys/id1590487745',
  GOOGLE_STORE: 'https://play.google.com/store/apps/details?id=com.statrys.statrys',
  TRUST_PILOT: 'https://www.trustpilot.com/review/statrys.com',
  INVOICE: 'https://invoice.statrys.com/signup',
  INVOICE_COMPANY_SETUP_URL: '/company-set-up',
  GUEST_BLOG: 'https://notionforms.io/forms/write-for-us-1',
  AIRWALLEX_REVIEW: 'https://notionforms.io/forms/airwallex-review',
  COMPANY_CREATION_CALENDAR: 'https://calendly.com/incorporation/discovery-company-creation-call',
  SINGAPORE_COMPANY_CREATION_CALENDAR: 'https://calendly.com/incorporation/discovery-call-company-creation-singapore',
  OCEAN_YOUTUBE_SHORT: 'https://www.youtube.com/embed/rHYkJRSu_pA?autoplay=1',
  BUSINESS_ACCOUNT_YOUTUBE_VIDEO: 'https://www.youtube.com/watch?v=qDKRpHcw20I',
  Talk_TO_US: 'https://calendly.com/statrysbusinessaccount/business-account-discovery-call',
  TALK_TO_FX_EXPERT: 'https://calendly.com/statrysbusinessaccount/fx-expert-call',
  SWITCH_TO_STATRYS: 'https://calendly.com/incorporation/switch-to-statrys',
  ACCOUNTING_CALENDAR: 'https://calendly.com/alessandro-meccheri-statrys/30min'
};

export const SHOW_NUMBER_OF_BLOGS = {
  TWELVE: 12,
  SIX: 6,
  EIGHTEEN: 18,
  TEN: 10,
  FIFTEEN: 15,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  NINE: 9,
  EIGHT: 8
};

export const BLOG_CATEGORIES_TYPE = {
  BANKING_FUNDAMENTALS: 'Banking Fundamentals',
  NEWS: 'News',
  COMPETITOR_REVIEWS: 'Competitor reviews'
};
export const CHAR_CODE = {
  ENTER_KEY_CODE: 13
};

export const SVG_TYPES = {
  STATRYS_LOGO: 'statrysLogo',
  BOOK_OPEN_BOOKMARK: 'bookOpenBookMark',
  EURO_IBAN_ACCOUNT: 'euroIbanAccount',
  CREDIT_CARD: 'creditCard',
  CURRENCY_EURO_DOLLAR_EXCHANGE: 'currencyEuroDollarExchange',
  TAG_DOLLAR: 'tagDollar',
  QUESTION_CIRCLE: 'questionCircle',
  BOOK_LIBRARY: 'bookLibrary',
  BOOK_OPEN: 'bookOpen',
  SINGLE_MAN_MAIL: 'singleManMail',
  TEAM_IDEA: 'teamIdea',
  NEWS_PAPER_READ: 'newsPaperRead',
  BUSINESS_PARTNER: 'businessPartner',
  CONTACT_US: 'contactUs',
  BULB: 'bulb',
  RATING_STARS: 'ratingStars',
  SEND_EMAIL: 'sendEmail',
  CONTACT_PHONE: 'contactPhone',
  PERFORMANCE_GRAPH: 'calculator',
  ACCOUNTING_CALCULATOR: 'stripeCalculator',
  INVOICE_GENERATOR: 'Invoice',
  PAYMENTS_BILLS: 'PAYMENTS_BILLS',
  GET_REWARDED: 'GET_REWARDED',
  WRITE_BLOG: 'WRITE_BLOG',
  VIDEO_GUIDE: 'VIDEO_GUIDE',
  QUIZ_QUESTION: 'QUIZ_QUESTION',
  AccountingHeader: 'AccountingHeader',
  InvoiceServiceHeader: 'InvoiceServiceHeader'
};
export const SPECIAL_CHARACTER_VALIDATION = {
  FOR_NAMES: /[%<>\\$#!@%^&*()?+'"]/,
  FOR_SPACE: /\s/g,
  FOR_NBSP: /(&nbsp;)*/g,
  FOR_COMMA: /[,.]/g
};

export const PRODUCT_PAGES_URL = {
  COMPANY_SECRETARY_URL: '/reviews/company-secretary-hong-kong',
  PRIVACY_POLICY_URL: '/terms-and-conditions/privacy-policy',
  HONGKONG_COMPANY_REGISTRATION: '/hong-kong-company-registration'
};

export const QUIZE_STEPS = {
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  SEVEN: 7,
  EIGHT: 8,
  NINE: 9,
  TEN: 10,
  ELEVEN: 11,
  TWELVE: 12,
  THIRTEEN: 13,
  FOURTEEN: 14,
  FIFTEEN: 15,
  SIXTEEN: 16,
  SEVENTEEN: 17,
  EIGHTEEN: 18
};

export const SENDGRID_DETAILS = {
  LIST_ID_PAYPAL_CALCULATOR_SIGNUP: '4cff10ad-80a6-40cc-ba03-53c4af866881'
};
export const SESSION_STORAGE_NAME = {
  COUNTRY_FOR_BUSINESS_ACCOUNT_REVIEW: 'countryForBusinessAccountReview',
  IS_BANNER_VISIBLE: 'isBannerVisible',
  REFERRER: 'referrer'
};

export const POST_TYPE = {
  ARTICLE: 'article',
  BLOG: 'blog',
  SILOS_SECTION: 'silos-section'
};

export const BA_QUIZE_RESULT_OPTIONS = {
  STATRYS: 'Statrys',
  AIRWALLEX: 'Airwallex',
  OTHER_FINTECH: 'Other',
  BANK: 'Bank',
  NO_PERFECT_OPTION: 'No perfect option'
};

export const TAX_QUIZ_STEPS = {
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  SEVEN: 7,
  EIGHT: 8,
  NINE: 9,
  TEN: 10
};

export const TAX_QUIZ_RESULTS = {
  MAY_BE_ELIGIBLE_FOR_OFFSHORE_CLAIM: 'May be eligible for offshore claim',
  MAY_BE_ELIGIBLE_FOR_PARTIAL_OFFSHORE_CLAIM: 'May be eligible for partial offshore claim',
  UNLIKELY_TO_BE_ELIGIBLE_FOR_OFFSHORE_CLAIM: 'Unlikely to be eligible for offshore claim'
};

export const TAX_QUIZ_ANSWER_SELECTED_OPTIONS = {
  SOME_INSIDE_SOME_OUTSIDE_HK: 'Some inside Hong Kong, some outside Hong Kong',
  STRICTLY_INSIDE_HK: 'Strictly in Hong Kong',
  ONLY_OUTSIDE_HK: 'Only outside Hong Kong'
};

export const BOOLEAN_YES_NO = {
  YES: 'Yes',
  NO: 'No'
};

export const KEY_MAPPING = {
  ENTER: 'enter'
};

export const PAYMENT_TYPE = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing'
};
export const FEES = process.env.COMPANY_CREATION_DISCOUNT
  ? {
      // Discount prices (new)
      FOR_PAY_PAL: 7700,
      SINGAPORE_FOR_PAY_PAL: 3000,
      COMPANY_CREATION: 770000, // assuming this is 100× the base fee
      COMPANY_CREATION_CAPTION: '7,700',
      SINGAPORE_COMPANY_CREATION_CAPTION: '3,000'
    }
  : {
      // Original prices (new)
      FOR_PAY_PAL: 8700,
      SINGAPORE_FOR_PAY_PAL: 3500,
      COMPANY_CREATION: 870000,
      COMPANY_CREATION_CAPTION: '8,700',
      SINGAPORE_COMPANY_CREATION_CAPTION: '3,500'
    };
export const HONG_HONG_COMPANY_CREATION_ORIGINAL_PRICING = [
  {
    title: 'HKD',
    price: '8,700'
  },
  {
    title: 'EUR',
    price: '1,074'
  },
  {
    title: 'USD',
    price: '1,118'
  }
];
export const SINGAPORE_COMPANY_CREATION_ORIGINAL_PRICING = [
  {
    title: 'SGD',
    price: '3,500'
  },
  {
    title: 'EUR',
    price: '2,490'
  },
  {
    title: 'USD',
    price: '2,594'
  }
];
export const HONG_KONG_COMPANY_CREATION_FEES_DROPDOWN = process.env.COMPANY_CREATION_DISCOUNT
  ? [
      {
        title: 'HKD',
        price: '7,700'
      },
      {
        title: 'EUR',
        price: '950'
      },
      {
        title: 'USD',
        price: '990'
      }
    ]
  : HONG_HONG_COMPANY_CREATION_ORIGINAL_PRICING;

export const SINGAPORE_COMPANY_CREATION_FEES_DROPDOWN = process.env.COMPANY_CREATION_DISCOUNT
  ? [
      {
        title: 'SGD',
        price: '3,000'
      },
      {
        title: 'EUR',
        price: '2,135'
      },
      {
        title: 'USD',
        price: '2,224'
      }
    ]
  : SINGAPORE_COMPANY_CREATION_ORIGINAL_PRICING;

export const currencyList = [
  { code: 'USD', backgroundColor: '#097D75', textColor: '#FFFFFF' },
  { code: 'EUR', backgroundColor: '#1B6BD3', textColor: '#FFFFFF' },
  { code: 'CNY', backgroundColor: '#C71E11', textColor: '#FFFFFF' },
  { code: 'RMB', backgroundColor: '#C71E11', textColor: '#FFFFFF' },
  { code: 'HKD', backgroundColor: '#E15741', textColor: '#FFFFFF' },
  { code: 'GBP', backgroundColor: '#180740', textColor: '#FFFFFF' },
  { code: 'SGD', backgroundColor: '#F9DBD1', textColor: '#C71E11' },
  { code: 'JPY', backgroundColor: '#FFFFFF', textColor: '#000000', borderColor: '#D9D9D9' },
  { code: 'AUD', backgroundColor: '#0E376C', textColor: '#FFFFFF' },
  { code: 'CHF', backgroundColor: '#F9DBD1', textColor: '#C71E11' },
  { code: 'NZD', backgroundColor: '#180740', textColor: '#FFFFFF' },
  { code: 'CAD', backgroundColor: '#FF4F42', textColor: '#FFFFFF' },
  { code: 'IDR', backgroundColor: '#C71E11', textColor: '#FFFFFF' },
  { code: 'INR', backgroundColor: '#FF8F00', textColor: '#FFFFFF' },
  { code: 'PHP', backgroundColor: '#0E376C', textColor: '#FFFFFF' },
  { code: 'TRY', backgroundColor: '#097D75', textColor: '#FFFFFF' },
  { code: 'VND', backgroundColor: '#C71E11', textColor: '#FFFFFF' },
  { code: 'KRW', backgroundColor: '#1B6BD3', textColor: '#FFFFFF' },
  { code: 'THB', backgroundColor: '#180740', textColor: '#FFFFFF' }
];

export const COUNTRIES_FLAG_URL = `${process.env.SITEURL}/countries`;

export const QUIZ_PAGE = {
  FX_PAGE: 'FX_PAGE',
  Second_BA: 'Second_BA',
  FIRST_BA: 'FIRST_BA'
};
